import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, callGameServerApi, getInlineLoader, isAlphanumeric, resolveOrientation } from '../Helpers';


export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";
  const [ error, setError ] = useState(false);
  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [ finalMessage, setFinalMessage ] = useState(false);

  const [ email, setEmail ] = useState("");

  

  const init = () => {
    appContext.changeOrientation(requiredOrientation);
    setReady(true);
  }


  const resetPwd = async (e) => {
    e.preventDefault();
    if(!loading) {
      if(email.length > 0) {
        setLoading(true);
        await callGameServerApi('reset-pwd', { email }).then(response => {
          if(response.status === 1) {
            setLoading(false);
            setFinalMessage(response.msg);
          } else {
            setLoading(false);
            setError(response.msg);
          }
        })
      } else {
        setError("Invalid email address");
      }
    }
  }



  useEffect(() => {
    if(appContext.auth) {
      //take to common area
      appContext.openHome();
    } else {
      //initialize
      init();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  return (
    <>
      <div className='FullPane'  style={{ paddingBottom: "var(--topBarheight)" }}>
        <div className='container'>
          <div className='row'>
            {
              (!finalMessage) ?
              <div className='col-md-6'>
                <h2 className='font-light text-goldish' style={{ marginTop: "calc(var(--topPaneHeight) * 0.5)" }}>Password Reset</h2>
                <small className='text-muted'>Here you can only reset your account if it was linked to an email address. Contact our support If your account was not linked to an email address</small>
                <h6 style={{ marginTop:"20px", marginBottom:"20px" }} className='font-light text-redish'>
                  {(error) ? error: ''}
                </h6>

                <form onSubmit={(e) => resetPwd(e)} style={{ marginTop:"10px" }}>
                  <div className='form-group'>
                    <label>Linked Email Address</label>
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value.trim())} maxLength={30} className='form-control'/>
                  </div>

                  <div className='form-group text-end'>
                    <button className='btn bg-faint-black btn-rounded'>Reset Password</button>
                  </div>
                </form>

                <div className='text-start font-light' style={{fontSize: "14px"}}>
                  You can also <a className='font-bold text-goldish' onClick={() => appContext.navTo({ item: 'signup' })}>Sign Up</a> or <a className='font-bold text-goldish' onClick={() => appContext.navTo({ item: 'signin' })}>Sign in</a>
                </div>
              </div>
              :
              <div className='col-12'>
                <h2 className='font-light text-goldish' style={{ marginTop: "calc(var(--topPaneHeight) * 0.5)" }}>Password Reset</h2>
                <small className='text-muted'>{email}</small>
                <h6 className='font-light'>
                  {finalMessage}
                </h6>

                <div className='text-start font-light' style={{fontSize: "14px", marginTop: "40px"}}>
                  You can <a className='font-bold text-goldish' onClick={() => appContext.navTo({ item: 'signup' })}>Sign Up</a> or <a className='font-bold text-goldish' onClick={() => appContext.navTo({ item: 'signin' })}>Sign in</a>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </>
  )
}
